import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CertificatedProvider } from '../../providers/certificated/certificated';
import { ValidatorProvider } from "../../providers/validator/validator";
import { AlertProvider } from "../../providers/alert/alert";

@IonicPage()
@Component({
  selector: 'page-certificated',
  templateUrl: 'certificated.html',
})
export class CertificatedPage {
  federalCode: any;
  public certificated: any[] = [];
  isCertificated: boolean;
  userName: string;
  userFederalCode: string;
  proofName: string;
  certificationValidityStart: string;
  certificationValidityEnd: string;
  certification: string;
  certificationStatus: string;
  status: string;
  noFederalCode: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private certificatedProvider: CertificatedProvider,
    private validatorProvider: ValidatorProvider,
    private alertProvider: AlertProvider,
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CertificatedPage');
  }

  public onBack(): void {
    this.navCtrl.pop();
  }

  doVerifyCertificated() {
    if (this.validatorProvider.isEmpty(this.federalCode)) {
      this.alertProvider.doAlert('Forneça o Nº CPF do candidato.', 'Atenção');
    } else if (!this.validatorProvider.isCpf(this.federalCode)) {
      this.alertProvider.doAlert('Forneça um CPF válido.', 'Atenção');
    } else {
      let that = this;
      that.certificated = [];
      this.certificatedProvider.doVerificationCertificated(this.federalCode).subscribe((certificated: any) => {
        that.certificated.push(certificated);
        if (that.certificated[0].length === 0) {
          console.log('CERTIFICADO OUT 0 ------>', that.certificated);
          that.noFederalCode = true;
        } else {
          if (that.certificated[0].length > 0) {
            console.log('CERTIFICADO OUT 1 ------>', that.certificated);
            that.isCertificated = true;
            that.noFederalCode = false;
            that.userName = that.certificated[0][0].userName;
            that.userFederalCode = this.federalCode;
            that.proofName = that.certificated[0][0].proofName;
            that.certificationValidityStart = that.certificated[0][0].certificationValidityStart;
            that.certificationValidityEnd = that.certificated[0][0].certificationValidityEnd;
            that.certification = that.certificated[0][0].certification;
            if (that.certificated[0][0].certificationStatus == 'A') {
              that.status = "Válida";
            } else {
              that.status = "Vencida";
            }
            that.certificationStatus = that.status;
          } else {
            that.isCertificated = false;
            that.noFederalCode = false;
          }
        }
      }, (error: any) => {
        console.log(error);
      });
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/certificated/certificated.ts